import { AxiosInstance } from "axios";
import { OIDCSessionService } from "../services/OIDCSessionService";

export const registerAuthInterceptor = (axiosClient: AxiosInstance) => {
  axiosClient.interceptors.request.use(async (request) => {
    const auth = OIDCSessionService.getCachedUser();
    if (auth) {
      if (auth) {
        const { access_token, token_type } = auth;
        request.headers!["Access-Control-Allow-Origin"] = "*";
        if (access_token) {
          request.headers!.Authorization = `${token_type} ${access_token}`;
        }
      }
    }
    return request;
  });
};
// ctx.request.config.TOKEN = () =>
//   Promise.resolve(
//     auth.isAuthenticated && auth.user ? auth.user.access_token : ""
//   );
